import { AxiosError } from 'axios'
import type { AxiosInstance } from 'axios'
import type { InternalAxiosRequestConfig } from 'axios'
import type { AxiosResponse } from 'axios'

const onRequest = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  return config
}

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error)
}

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response
}

const onResponseError = async (error: AxiosError): Promise<AxiosError> => {
  if (error.message === 'Request failed with status code 401') {
    localStorage.clear()
    window.location.reload()
  }
  return Promise.reject(error)
}

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError)
  axiosInstance.interceptors.response.use(onResponse, onResponseError)
  return axiosInstance
}
